import { render, staticRenderFns } from "./ViewDaysBackRequest.vue?vue&type=template&id=58900514"
import script from "./ViewDaysBackRequest.vue?vue&type=script&lang=js"
export * from "./ViewDaysBackRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports